import React, { useState } from 'react';
import { generateSocialPost, copyToClipboard } from '../../../utils/socialSharing';

const ShareModal = ({ isOpen, onClose, shareMessage }) => {
  const [shareStyle, setShareStyle] = useState('insight');

  if (!isOpen) return null;

  const handleCopy = async () => {
    const result = await copyToClipboard(generateSocialPost(shareMessage, shareStyle));
    if (result.success) {
      alert('✅ Copied to clipboard! Ready to share on social media.');
      onClose();
    } else {
      alert('❌ Failed to copy. Please select and copy manually.');
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        maxWidth: '500px',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto'
      }}>
        <div style={{ padding: '20px', borderBottom: '1px solid #E2E8F0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{ margin: 0, color: 'var(--deep-blue)' }}>📱 Share Your Insight</h3>
            <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer',
                color: '#718096'
              }}
            >
              ×
            </button>
          </div>
        </div>
        
        <div style={{ padding: '20px' }}>
          <p style={{ color: '#718096', marginBottom: '16px' }}>
            Activate your <strong>I-WE Clarity MindStream</strong> by sharing this wisdom with others!
          </p>
          
          {/* Style Selection */}
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Post Style:</label>
            <div style={{ display: 'flex', gap: '8px' }}>
              {[
                { value: 'insight', label: '💡 Insight' },
                { value: 'gratitude', label: '🙏 Gratitude' },
                { value: 'transformation', label: '✨ Transform' },
                { value: 'encouragement', label: '💪 Encourage' }
              ].map(style => (
                <button
                  key={style.value}
                  onClick={() => setShareStyle(style.value)}
                  style={{
                    flex: 1,
                    padding: '8px',
                    border: shareStyle === style.value ? 'none' : '2px solid var(--primary-blue)',
                    background: shareStyle === style.value 
                      ? 'linear-gradient(135deg, var(--primary-blue), var(--light-blue))' 
                      : 'white',
                    color: shareStyle === style.value ? 'white' : 'var(--primary-blue)',
                    borderRadius: '8px',
                    fontSize: '0.75rem',
                    cursor: 'pointer',
                    fontWeight: '500'
                  }}
                >
                  {style.label}
                </button>
              ))}
            </div>
          </div>
          
          {/* Post Preview */}
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Your Post:</label>
            <textarea
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #E2E8F0',
                fontSize: '0.875rem',
                fontFamily: 'inherit',
                resize: 'vertical'
              }}
              rows="6"
              value={generateSocialPost(shareMessage, shareStyle)}
              readOnly
            />
            <small style={{ color: '#718096' }}>
              {generateSocialPost(shareMessage, shareStyle).length} characters
            </small>
          </div>
          
          <div style={{
            padding: '12px',
            background: 'rgba(74, 144, 226, 0.1)',
            borderRadius: '8px',
            marginBottom: '16px'
          }}>
            <small style={{ color: 'var(--primary-blue)' }}>
              <strong>Tip:</strong> This activates your Clarity MindStream (I-WE relationship) 
              by expressing Value to your community! 🌟
            </small>
          </div>
        </div>
        
        <div style={{ 
          padding: '20px', 
          borderTop: '1px solid #E2E8F0',
          display: 'flex',
          gap: '12px',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              background: '#E2E8F0',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleCopy}
            style={{
              padding: '10px 20px',
              background: 'linear-gradient(135deg, var(--accent-teal), #48C9B0)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            📋 Copy to Clipboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
